<svg width="62" height="82" viewBox="0 0 62 82" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.89032 80.6715C5.86624 80.6836 5.84197 80.6955 5.81754 80.7072C3.83835 81.6535 1.46676 80.8162 0.520442 78.837C0.285533 78.3457 0.160533 77.8302 0.135625 77.3184V40.8725L36.6035 62.7354C36.6035 62.7354 18.5798 73.293 18.1394 73.5743C17.3947 74.031 10.8279 77.8286 5.89032 80.6715Z" fill="url(#paint0_linear_17_30)"/>
<path d="M0.130371 3.57514C0.130371 16.5801 0.13636 22.4116 0.84367 24.5277C1.61771 26.8046 3.2592 29.1886 5.0208 30.5949L47.8567 56.1128L55.72 51.5732C58.8963 49.4704 61.352 45.7696 61.7657 41.765C62.2328 37.2246 60.1376 32.5102 56.4542 29.8047L5.94587 0.451371C5.3899 0.155277 4.75523 0.0966797 4.08137 0.0966797C2.02692 0.0966797 0.336786 1.57525 0.130371 3.57514Z" fill="url(#paint1_linear_17_30)"/>
<defs>
<linearGradient id="paint0_linear_17_30" x1="30.914" y1="53.1945" x2="-6.25881" y2="1.87165" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF0072"/>
<stop offset="1" stop-color="#FF5120"/>
</linearGradient>
<linearGradient id="paint1_linear_17_30" x1="30.914" y1="53.1945" x2="-6.25881" y2="1.87165" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF0072"/>
<stop offset="1" stop-color="#FF5120"/>
</linearGradient>
</defs>
</svg>
